export const BASE_API = "https://swapi.dev/api";
